import React, { useContext, useEffect } from 'react';
import styles from './ActivityLog.module.scss';
import { withRouter } from 'react-router-dom';
import {
	Header,
	PageAuth,
	PageContainer,
	Sidebar,
	SideMenu,
	Page,
	PageHeader,
	GlobalAlert,
	Filters,
	PERMISSIONS,
} from '../..';
import { adminPages, PropertyType, useStore } from '../../../common';
import { getRows } from './RowProvider';
import { Table, Pagination } from 'esa-ui-library';
import { AuthContext } from '../../../logic';
import { PartnersFilter, UsersFilter, DateFilter } from '../../components/Filters/components';
import useFilters from '../../../common/hooks/useFilters';

const ActivityLogComponent = (props: PropertyType): JSX.Element => {
	const [state, dispatch] = useStore();
	const { logs, rows, columns, pagesTotal, currentPage, logsLoading, perPage } = state;
	const { user, token } = useContext(AuthContext);
	const { id } = props.match.params;
	const { onFilter } = useFilters();

	const filterUserLogs = () => {
		onFilter([{ name: 'user_id', value: id }]);
	};

	useEffect(() => {
		dispatch('LOADING', true);
		dispatch('PARTNERS_INIT', user);
		dispatch('USERS_INIT', { token });
		if (id) return filterUserLogs();
		dispatch('LOGS_INIT', {
			token,
			page: currentPage,
			perPage,
		});
	}, []);

	useEffect(() => {
		dispatch('UPDATE_ROWS', getRows(logs));
	}, [logs]);

	const onPageChange = (page: number | string) => {
		dispatch('LOADING', true);
		dispatch('PAGE_UPDATE', { token, page, perPage });
	};

	const onPerPageChange = (value: PropertyType) => {
		const perPage = value[0].value;
		dispatch('LOADING', true);
		dispatch('PER_PAGE', perPage);
		dispatch('PAGE_UPDATE', { token, currentPage, perPage });
	};

	return (
		<>
			<Header dataId='header' />
			<PageAuth onlyAdmin permission={PERMISSIONS.canViewUser}>
				<PageContainer>
					<Sidebar dataId='admin-sidebar' opened>
						<SideMenu options={adminPages} title='Admin' />
					</Sidebar>
					<Page>
						<PageHeader title='Activity Log' />
						<section className={styles.PageContent}>
							{!id && (
								<Filters>
									<DateFilter />
									<PartnersFilter />
									<UsersFilter />
								</Filters>
							)}
							<Table titles={columns} data={rows} className={styles.LogTable} collapsible isLoading={logsLoading} />
							{logs?.length > 0 && (
								<Pagination
									perPage={perPage}
									showPerPage
									onPerPage={onPerPageChange}
									total={pagesTotal}
									current={currentPage}
									onChange={onPageChange}
								/>
							)}
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

const ActivityLog = withRouter(ActivityLogComponent);

export { ActivityLog };
